<template>
  <div v-if="item">
    <div class="row">
      <div class="col-12 col-sm">
        <ez-input v-model="item.name" :error="errors['name']">Name</ez-input>
      </div>
      <div class="col col-sm-3 col-md-2">
        <ez-select2
          :options="itemTypes"
          :allow-clear="true"
          v-model="item.type"
          :error="errors['type']">
          Type
        </ez-select2>
      </div>
      <div class="col col-sm-3 col-md-2">
        <ez-select2 v-if="['PF Playtest', 'PFRPG2', 'Embers RPG'].includes(item.ruleset)"
          :options="$rulesets[item.ruleset].getBulkOptions()"
          :allow-clear="true"
          v-model="item.weight"
          :error="errors['weight']">
          Bulk
        </ez-select2>
        <ez-input v-model.number="item.weight" :error="errors['weight']" v-else>Weight (lb)</ez-input>
      </div>
      <div class="col-2 col-md-1" v-if="isAdmin">
        <ez-toggle v-model="item.stock" :error="errors['stock']">Stock</ez-toggle>
      </div>
    </div>

    <div class="row" v-if="item.stock">
      <div class="col">
        <ez-input v-model="item.publisher" :error="errors['publisher']">Publisher</ez-input>
      </div>
      <div class="col">
        <ez-input v-model="item.source" :error="errors['source']">Source</ez-input>
      </div>
      <div class="col-2 col-md-1">
        <ez-toggle v-model="item.ogl" :error="errors['ogl']">OGL</ez-toggle>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <ez-input v-model="item.summary" :error="errors['summary']">Summary</ez-input>
      </div>
      <div class="col col-sm-4" v-if="isAdmin">
        <ez-select2
          :options="getOptions"
          :allow-clear="true"
          v-model="item._parent"
          :error="errors['_parent']">
          Parent
        </ez-select2>
      </div>
    </div>
    <label>Description</label>
    <markdown-editor v-model="item.description"></markdown-editor>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import EzToggle from "../shared/_VueEzToggle.vue";
import EzInput from "../shared/_VueEzInput.vue";
import EzSelect2 from "../shared/_VueEzSelect2.vue";
import { markdownEditor } from "vue-simplemde";

export default {
  name: "item-form",
  components: {
    EzToggle,
    EzInput,
    EzSelect2,
    markdownEditor,
  },
  props: ["item", "errors"],
  computed: {
    ...mapState({
      ruleset: (state) => state.session.user.settings.ruleset,
    }),
    ...mapGetters({
      isAdmin: "isAdmin",
      getItemOptions: "items/getOptions",
    }),
    getOptions() {
      return this.getItemOptions.filter((x) => x.type === this.item.type);
    },
    itemTypes() {
      let itemTypes = this.$rulesets[this.ruleset].getItemTypes();
      return itemTypes;
    },
  },
};
</script>
